import { enumParser } from '#validation/common/parsers';
import { LoginType } from '../constants';
export const loginTypeParser = enumParser(LoginType);
